import CookiesU from 'universal-cookie';
const cookies = new CookiesU();

const Globales = {
  Url: process.env.NODE_ENV === 'production' ?
    // 'http://18.207.253.171:5001/'  //Servidor de pruebas
    'https://educationapi.dostics.com.mx/'     //Servidor productivo

    : 'http://localhost:5001/',
  // : 'https://apply-modules-nvidia-coupled.trycloudflare.com/',

  token: 'Bearer ' + cookies.get('token'),

  usuario: localStorage.getItem("Usuario"),
  version: "1.2.1",
}
export default Globales;